import type { WwwExperiments } from '@mentimeter/splitio';
import type { FlagGroup } from '../types';

export const GROUPS: FlagGroup<WwwExperiments>[] = [];
